export const THEME_STORAGE_KEY = "theme-preference";
export const LEGACY_THEME_STORAGE_KEY = "theme";

export function isThemeMode(value) {
    return value === "light" || value === "dark";
}

export function getSystemTheme() {
    if (typeof window === "undefined") {
        return "light";
    }

    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

export const themeInitScript = `
(() => {
    const storageKey = "${THEME_STORAGE_KEY}";
    const legacyStorageKey = "${LEGACY_THEME_STORAGE_KEY}";
    const stored = window.localStorage.getItem(storageKey) || window.localStorage.getItem(legacyStorageKey);
    const systemTheme = window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
    const theme = stored === "light" || stored === "dark" ? stored : systemTheme;
    if (!window.localStorage.getItem(storageKey) && (stored === "light" || stored === "dark")) {
        window.localStorage.setItem(storageKey, stored);
    }
    document.documentElement.setAttribute("data-theme", theme);
    document.documentElement.style.colorScheme = theme;
})();
`;
